export enum DistributionStatus {
  unknown = "Unknown",
  created = "Created",
  emailSent = "EmailSent",
  emailFailed = "EmailFailed",
  emailPending = "EmailPending",
}

export function getTextForDistributionStatus(
  status: DistributionStatus
): string {
  switch (status) {
    case DistributionStatus.unknown:
      return "Unknown";
    case DistributionStatus.created:
      return "No email sent";
    case DistributionStatus.emailSent:
      return "Email sent";
    case DistributionStatus.emailFailed:
      return "Email failed";
    case DistributionStatus.emailPending:
      return "Email pending";
  }
}
